import React from "react";
import Layout from "../components/App/Layout";
import SEO from "../components/App/SEO";

import Section from "../components/Selfcenter/Section";
import Features from "../components/Selfcenter/Features";
import OtherBooks from "../components/Selfcenter/OtherBooks";

const Selfcenter = () => {
  return (
    <Layout>
      <SEO
        title="大任软件- HCM人力资本管理系统"
        ogTitle="人员管理系统_人力资源管理平台-成都市大任软件有限责任公司"
        keywords="HCM人力资本管理系统"
        description="大任软件专注于提供高效、全面的HCM（人力资本管理系统）解决方案，助力企业优化人才管理，实现人力资源的数字化转型与效能提升"
      />

      <Section />
      <Features />
      <OtherBooks />
    </Layout>
  );
};

export default Selfcenter;
